import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadUserById,
    setUserProfileView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const ProfileView = () => {
    const profile = useSelector((state: StoreType) => state.userProfile.profileView)
    const reloadView = useSelector((state: StoreType) => state.userProfile.reloadView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadUserById(userData.userId)
        .then((res) => {
            dispatch(setUserProfileView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    if (!profile) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${profile.firstName} ${profile.lastName}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <Form />
            </PageContent>
        </Container>
    )
}
export default ProfileView
